import { CompanySettings } from '@innovyze/stylovyze';
import { createAction } from '@reduxjs/toolkit';
import {
	CompanySettingsParams,
	CompanySettingsParamsWithCompanyId,
} from '@Types/companySettings.types';
import { addNamespace } from '@Utils/actions';

// Get Sensor Configuration By Sensor Id
export const getCompanySettingsByCompanyId =
	createAction<CompanySettingsParamsWithCompanyId>(
		addNamespace('configurations/getCompanySettingsByCompanyId'),
	);

export const getCompanySettingsByCompanyIdResolved =
	createAction<CompanySettingsParamsWithCompanyId>(
		addNamespace('configurations/getCompanySettingsByCompanyId/resolved'),
	);

export const getCurrentCompanySettings = createAction<CompanySettingsParams>(
	addNamespace('configurations/getCompanySettingsByCompanyId'),
);

export const getCurrentCompanySettingsResolved = createAction<CompanySettings>(
	addNamespace('configurations/getCompanySettingsByCompanyId/resolved'),
);
export const getCurrentCompanySettingsRejected = createAction(
	addNamespace('configurations/getCompanySettingsByCompanyId/rejected'),
);

export const updateCurrentCompanySettings = createAction<
	Partial<CompanySettings>
>(addNamespace('configurations/updateCompanySettingsByCompanyId'));

export const updateCurrentCompanySettingsResolved = createAction<
	Partial<CompanySettings>
>(addNamespace('configurations/updateCompanySettings/resolved'));

export const updateCurrentCompanySettingsRejected = createAction<
	Partial<CompanySettings>
>(addNamespace('configurations/updateCompanySettings/rejected'));
